<template>
   <div>
        <Breadcrumb :headers="headers"></Breadcrumb>
        <List 
            url="getProjectRegistrationList"
            deleteUrl="deleteProjectRegistration" 
            :data="searchData" 
            :tanle="tanle" 
            :update="updateList" 
            :afterList="dealListData"
            :operat="operat"
            @add="add"
            @edit="edit"
            @info="info"
            @setStatus="setStatus"
            :isAdd="this.type === 'null' || this.type === '1' || this.type === '2'"
            >
           <div slot="Filter">
                <label style="margin-left:10px;">Project Registration Status：</label>
                <el-select v-model="searchData.Status" placeholder="">
                    <el-option
                        v-for="item in statusList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <el-input v-model="searchData.Key" placeholder="Project Name" style="width:300px;margin-left:20px;"></el-input>
                <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
            </div>
        </List>
        <SetStatusBox :id="statusForm.id" :status="statusForm.Status" v-if="statusBlock" @close="statusBlock = false" @update="updateList++"></SetStatusBox>
   </div>
</template>
<script>
import List from "../components/common/List.vue";
import SetStatusBox from "@/components/ProjectRegistration/SetStatusBox.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
import { ORDERSTATUS,orderStatusList } from "@/components/ProjectRegistration/data.js";
import { unshiftAll } from "@/methods/selection.js";
export default {
    components:{
        List,
        SetStatusBox,
        Breadcrumb
    },
    data () {
        return {
            tanle:[{name:"ProjectName",label:"Project Name",width:"300px"},{name:"ProjectLocation",label:"Project Location"},/* {name:"EndUserName",label:"End User Name"},{name:"devices",label:"Akuvox Proposal",type:1,width:'200px'},
            {name:"competitorDevices",label:"Competitors Information",type:1,width:'200px'}, */{name:"WhentoDeploy",label:"When to Deploy/Ship",width:"250px"},{name:"WinRate",label:"Win Rate"},{name:"StatusName",label:"Status"}],
            headers:[{label:"Home",path:"/dashboard"},{label:"Project Registration",path:"/projectRegistration"}],
            searchData:{
                Key:"",
                Status:"all"
            },
            type:"",
            updateList:0,
            updateType: "add",
            updateForm: {},
            updateBlock: false,
            statusList:unshiftAll(orderStatusList),
            operat:[],
            statusForm:{
                id:"",
                Status:""
            },
            statusBlock:false,
            customerList:[]
        };
    },
    mounted () {
        this.type = localStorage.getItem("type");
        if (this.type === '0' || this.type === '1' || this.type === '2')
        {
            this.operat.push({
                text:"Status",
                eventName:"setStatus",
                type:'danger',
                method (data) {
                    return (data.Status !== "2"  );
                }
            });
        }
        if (this.type === 'null' || this.type === '1' || this.type === '2')
        {
            this.operat.push(  {
                text: "Delete",
                eventName: "delete",
                type: "danger",
                PretreatMethod: "confirmDelete"
            });
        }
        if (this.type === 'null' || this.type === '0' || this.type === '1' || this.type === '2')
        {
            this.operat.push(  {
                text:"Edit",
                eventName:"edit",
                type:'primary',
                method (data) {
                    return (data.Status !== "2");
                } 
            });
        }
        if (this.type === '0' || this.type === '1' || this.type === 'null' || this.type === '2')
        {
            this.operat.push(  {
                text:"Info",
                eventName:"info",
                type:'primary'/* ,
                method (data) {
                    return (data.Status !== "1");
                } */ 
            });
        }
    },
    methods:{
        dealListData (data) {
            for(let i in data) {
                data[i].StatusName = ORDERSTATUS[data[i].Status];
            }
            return data;
        },
        /*  add () {
            this.updateForm = {
                ExpectTime:"",
                CompanyName:"",
                Description:"",
                Location:"",
                Partner:""
            };
            this.updateType = "add";
            this.updateBlock = true;
        },
        edit (val) {
            this.updateForm = val;
            this.updateForm.ExpectTime = new Date(val.ExpectTime); 
            this.updateType = "edit";
            this.updateBlock = true;
        }, */
        add () {
            this.$router.push("/projectRegistrationUpdate");
        },
        edit (val) {
            this.$router.push(`/projectRegistrationUpdate?id=${val.ID}`);   
        },
        info (val) {
            this.$router.push(`/projectRegistrationInfo?id=${val.ID}`);   
        },
        setStatus (val) {
            this.statusForm.id = val.ID;
            this.statusForm.Status = val.Status;
            this.statusBlock = true;
        }
    }
};
</script>
